import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import MpApplication from './MpApplication'
import MpFileView from './MpFileView'
import MpReturn from './MpReturn'

const Mp = () => {
  const { path } = useRouteMatch()

  const [selectedSection, setSelectedSection] = useState('mp')

  const actionListModule = useSelector(
    getUserModuleActions('compensation-approval', 'compensation', 'mp')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'compensation-approval',
      'compensation',
      'mp',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="mp">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('mp')
                    }}
                    eventKey="mp"
                  >
                    MP Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('mp-return')
                    }}
                    eventKey="mp-return"
                  >
                    MP Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'mp' ? (
              <>
                {checkPermission('view', actionListModule) && <MpApplication />}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <MpReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <MpFileView type="view" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <MpFileView type="file-return" {...props} />}
      />
    </Switch>
  )
}

export default Mp
